import { useState, useEffect } from 'react';
import { cmApi } from '../../api.js';

const AMOUNT_FIELD = { statex: 'budget', paid_media: 'media_cost', offline: 'media_cost', direct_buys: 'media_cost' };
const BRAND_FIELD = { statex: 'brand_name', paid_media: 'brand', offline: 'brand', direct_buys: 'brand' };
const CHANNEL_FIELD = { statex: 'channel', paid_media: 'platform', offline: 'channel', direct_buys: 'channel' };

// Lets an admin exclude a known-bad row from downstream calculations without deleting it —
// it stays in the raw table (and this list) with excluded=true.
export default function BatchRowsBrowser({ sourceType, batchId }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const [busyId, setBusyId] = useState(null);

  const load = () => {
    setLoading(true);
    cmApi.getBatchRows(sourceType, batchId)
      .then(d => setRows(d.rows || []))
      .catch(e => setErr(e.message))
      .finally(() => setLoading(false));
  };

  useEffect(load, [sourceType, batchId]);

  const toggle = async (row) => {
    setBusyId(row.id);
    try {
      const reason = row.excluded ? null : window.prompt('Reason for excluding this row (optional):') || null;
      await cmApi.setRowExcluded(sourceType, row.id, !row.excluded, reason);
      load();
    } catch (e) {
      setErr(e.message);
    } finally {
      setBusyId(null);
    }
  };

  if (loading) return <p style={{ fontSize: 12, color: '#8C94A0' }}>Loading rows…</p>;
  if (err) return <p style={{ fontSize: 12, color: '#A32B2B' }}>{err}</p>;
  if (rows.length === 0) return <p style={{ fontSize: 12, color: '#8C94A0' }}>No rows found for this batch.</p>;

  const brandF = BRAND_FIELD[sourceType], channelF = CHANNEL_FIELD[sourceType], amountF = AMOUNT_FIELD[sourceType];

  return (
    <div style={{ maxHeight: 320, overflowY: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 11 }}>
        <thead>
          <tr style={{ textAlign: 'left', color: '#8C94A0', textTransform: 'uppercase', fontSize: 10, position: 'sticky', top: 0, background: '#FFFFFF' }}>
            <th style={{ padding: '4px 8px' }}>Advertiser</th>
            <th style={{ padding: '4px 8px' }}>Channel</th>
            <th style={{ padding: '4px 8px' }}>Amount</th>
            <th style={{ padding: '4px 8px' }}></th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.id} style={{ borderTop: '1px solid #E3E2DD', opacity: r.excluded ? 0.5 : 1 }}>
              <td style={{ padding: '4px 8px' }}>{r[brandF]}</td>
              <td style={{ padding: '4px 8px' }}>{r[channelF]}</td>
              <td style={{ padding: '4px 8px' }}>{r[amountF]}</td>
              <td style={{ padding: '4px 8px' }}>
                <button onClick={() => toggle(r)} disabled={busyId === r.id} style={{
                  background: 'none', border: '1px solid #E3E2DD', borderRadius: 8, cursor: 'pointer',
                  color: r.excluded ? '#2E6B4F' : '#A32B2B', fontSize: 10, padding: '2px 8px',
                }}>{r.excluded ? 'Include' : 'Exclude'}</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
